// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-modal-title{font-weight:bold}.message-modal-title>img{margin-right:5px;border-radius:100%;margin-right:10px;width:60px;height:60px;object-fit:cover}.message-modal-text{resize:none}.message-modal-footer{display:flex;justify-content:center;border:none}.message-modal-submit{width:100%}", ""]);
// Exports
module.exports = exports;
